import { useClassNames } from "@/utils/classNames";

import { ButtonGroupProps, ButtonGroupOrientation } from "./types";
import styles from "./ButtonGroup.module.scss";

/**
 * ButtonGroup component that renders a group of buttons with optional orientation.
 *
 * @param orientation - Orientation of the button group, either horizontal or vertical
 * @param className - Additional CSS class for styling
 * @param children - Button component children
 * @param attrs - Additional HTML attributes for the div element
 * @returns A button group component
 *
 * @example
 * ```tsx
 * <ButtonGroup>
 *   <Button>Restart</Button>
 *   <Button>Go Live</Button>
 * </ButtonGroup>
 * ```
 */
const ButtonGroup = ({
  orientation = ButtonGroupOrientation.Horizontal,
  className,
  children,
  ...attrs
}: ButtonGroupProps) => {
  const cn = useClassNames(
    styles,
    styles["button-group"],
    orientation === ButtonGroupOrientation.Vertical && styles["vertical"],
    className,
  );

  return (
    <div className={cn} {...attrs}>
      {children}
    </div>
  );
};

export { ButtonGroup };
